import { motion } from "framer-motion";
import { Check } from "lucide-react";

export const FeatureCard = ({ feature, selected, onToggle }) => {
  const Icon = feature.icon;
  return (
    <motion.button
      type="button"
      onClick={onToggle}
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.97 }}
      aria-pressed={selected}
      data-testid={`feature-card-${feature.id}`}
      className={`relative flex flex-col items-start rounded-2xl border p-5 text-left transition-[background-color,border-color,box-shadow] duration-300 ${
        selected
          ? "border-jade bg-jade/[0.07] shadow-[0_16px_40px_-22px_rgba(35,83,71,0.7)]"
          : "border-jade/10 bg-white/80 shadow-ambient backdrop-blur-sm hover:border-jade/30"
      }`}
    >
      <span
        className={`flex h-11 w-11 items-center justify-center rounded-xl transition-colors duration-300 ${
          selected ? "bg-jade text-paper" : "bg-jade/[0.07] text-jade"
        }`}
      >
        <Icon className="h-5 w-5" strokeWidth={1.6} />
      </span>
      {selected && (
        <motion.span
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          className="absolute right-4 top-4 flex h-5 w-5 items-center justify-center rounded-full bg-jade text-paper"
        >
          <Check className="h-3 w-3" strokeWidth={3} />
        </motion.span>
      )}
      <span className="mt-4 text-sm font-medium text-ink">{feature.label}</span>
      <span className="mt-1 text-sm text-ink2/70">
        £{feature.price}
        {feature.unit}
      </span>
      {feature.monthly && (
        <span className="mt-2 rounded-full bg-amber-100/70 px-2 py-0.5 text-xs font-medium text-amber-800" data-testid={`feature-monthly-${feature.id}`}>
          +£{feature.monthly}/mo
        </span>
      )}
    </motion.button>
  );
};
